// Le studio annonce une demande fermée par le back jusqu'à ce que le client la lise. Ce qu'il a
// déjà lu est retenu ici, pour ne pas le lui répéter à chaque visite.
const STORAGE_KEY = 'subscription.acknowledgedClosedChangeId';

export const acknowledgeClosedChange = (id: id) => localStorage.setItem(STORAGE_KEY, String(id));

export const isClosedChangeAcknowledged = (id: id) => localStorage.getItem(STORAGE_KEY) === String(id);
